<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-date-range`]" width="1em" height="1em" v-bind="$attrs"><rect x="3.249" y="4.5" width="17.502" height="15.752" rx="3" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><path d="M3.24902 9.02344H20.7507" stroke="#165DFF" stroke-width="1.66"/><path d="M7.62451 2.75V5.7888M16.3752 2.75V5.7888" stroke="#165DFF" stroke-width="1.66" stroke-linecap="round"/><path d="M16.0798 15.2891H7.92065V13.6289H16.0798V15.2891Z" :fill="useCurrentColor ? 'currentColor' : '#00BBD8'"/><path d="M8.31083 11.9071C8.63497 11.5831 9.16054 11.583 9.48466 11.9071C9.80866 12.2313 9.80869 12.7569 9.48466 13.081L8.1077 14.4579L9.48466 15.8349C9.80863 16.159 9.80874 16.6846 9.48466 17.0087C9.16055 17.3325 8.63488 17.3326 8.31083 17.0087L6.34696 15.0448C6.02292 14.7208 6.02311 14.1952 6.34696 13.871L8.31083 11.9071ZM14.5149 11.9071C14.839 11.583 15.3646 11.5831 15.6888 11.9071L17.6526 13.871C17.9766 14.1951 17.9767 14.7207 17.6526 15.0448L15.6888 17.0087C15.3646 17.3325 14.839 17.3326 14.5149 17.0087C14.1909 16.6847 14.1911 16.159 14.5149 15.8349L15.8919 14.4579L14.5149 13.081C14.1909 12.7569 14.1911 12.2313 14.5149 11.9071Z" :fill="useCurrentColor ? 'currentColor' : '#00BBD8'"/></svg>
</template>
<script>

export default {
  name: 'IconColorDateRange',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
